$(document).ready(function () {
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    arrows: true,
    centerMode: false,
    centerPadding: '0px',
    responsive: [

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  setTimeout(function(){
    $('.product-like-list .product-list').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      horizontal: true,
      infinite: true,
      autoplay: false,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '50px',
          }
        }
      ]
    });
   },2000);

  setTimeout(function(){
    $('.product-like-list .concrete-ul').slick({
      arrows: true,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      horizontal: true,
      infinite: true,
      autoplay: false,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [
        
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '140px',
          }
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '50px',
          }
        }
      ]
    });
  },1500);


});
function getSelectedVariantValues() {
   let selectedStrings = [];

  $('variant-selects fieldset').each(function () {
    const optionName = $(this).find('legend').clone().children('span').remove().end().text().trim();;
    const optionValue = $(this).find('input[type="radio"]:checked').val();
    if (optionValue) {
      selectedStrings.push(optionName + ': ' + optionValue);
    }
  });
  
  return selectedStrings;
}
// On variant change
// $(document).on('change', 'variant-selects input[type="radio"]', function () {
//   const selectedStrings = getSelectedVariantValues();
//   const finalString = selectedStrings.join(' | ');
//   //console.log(finalString);
// });
$("#product-enquire-button").on("click",function(){
      let prodname = $('h1').text().trim();
      const selectedStrings = getSelectedVariantValues();
      const finalString = selectedStrings.join(' | ');
      let mergedString = prodname;
      if (finalString) {
        mergedString += ' | ' + finalString;
      }
      //const mergedString = prodname + ' | ' + finalString;
      console.log(mergedString);
      setTimeout(function(){
        $("#get_product_info").val(mergedString);
      },800);
  });

